import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Brooke Clifton
 * id A4A9C031-02B0-45C7-B9C8-EA1541DB9A38
 * name lightning-bolt
 * version: 5.1.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lightning-bolt.svg
 * tags
 * - Home Automation 
 * - Weather 
 */
export const LightningBoltIcon = createSvgIcon(<><path d="M11 15H6L13 1V9H18L11 23V15Z" /></>, 'LightningBoltIcon');
export default LightningBoltIcon